/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const deleteUserDataSchema = z.object({
	userId: z.string(),
	organisationId: z.string(),
})

export type DeleteUserDataSchema = z.infer<typeof deleteUserDataSchema>
